import { Modal, Box, Typography, IconButton } from '@mui/material';
import { Close } from '@mui/icons-material';
import ReactMarkdown from 'react-markdown';

const modalStyle = {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    width: { xs: '90%', sm: 600 },
    bgcolor: 'background.paper',
    boxShadow: 24,
    p: 4,
    borderRadius: 2,
};

// Helper to format dates to PDT
const formatDate = (dateString) => {
    if (!dateString) return 'N/A';
    return new Date(dateString).toLocaleString('en-US', {
        timeZone: 'America/Los_Angeles', // PDT
        dateStyle: 'medium',
        timeStyle: 'short',
    });
};

export default function HotTopicModal({ open, onClose, hotTopic }) {
    if (!hotTopic) return null;

    return (
        <Modal open={open} onClose={onClose}>
            <Box sx={modalStyle}>
                <IconButton
                    onClick={onClose}
                    sx={{ position: 'absolute', top: 8, right: 8 }}
                >
                    <Close />
                </IconButton>
                <Typography variant="h6" component="h2" sx={{ mb: 2 }}>
                    Hot Topic Details
                </Typography>
                
                <Box sx={{ maxHeight: '60vh', overflowY: 'auto' }}>
                    <ReactMarkdown linkTarget="_blank">
                        {hotTopic.content || ''}
                    </ReactMarkdown>
                </Box>

                <Box sx={{ mt: 3, pt: 2, borderTop: '1px solid #eee' }}>
                    <Typography variant="caption" display="block">
                        <strong>Client:</strong> {hotTopic.client_name} ({hotTopic.client_code})
                    </Typography>
                    <Typography variant="caption" display="block">
                        <strong>Valid From (PDT):</strong> {formatDate(hotTopic.valid_from)}
                    </Typography>
                     <Typography variant="caption" display="block">
                        <strong>Valid Till (PDT):</strong> {formatDate(hotTopic.valid_till)}
                    </Typography>
                </Box>
            </Box>
        </Modal>
    );
}

